import React from "react";
import BuyerSidebar from "./common/BuyerSidebar";
import { Link } from "react-router-dom";
import OrderCard from "./comoponent/OrderCard";
import ProfileSidebar from "../pages/common/ProfileSidebar";

const MyOrderDetail = () => {
  const orders = [
    {
      orderId: "WT858589",
      productName: "Woolen clothes for elders",
      productImage: "/images/woolen_cloths.jpg",
      productBy: "YMCA Foundation",
      price: 200,
      quantity: 1,
      status: "Confirmed",
      deliveryDate: "19 Aug 2025",
      trackingId: "WT764785",
    },
  ];

  // Dummy shipping & payment details
  const shippingAddress = {
    name: "Yon Lee",
    address: "123 Orchard Road, #05-678\nLucky Plaza, Singapore 238863",
    country: "IN",
    phone: "98999889990",
  };

  const paymentInfo = {
    subtotal: "INR 9999",
    shipping: "INR 0",
    discount: "INR 2500",
    total: "INR 7499",
    mode: "Online",
    status: "Successful",
  };

  return (
    <div className="all_suport_bg manages_top">
      <section className="ser_v_araeea profiles">
        <div className="container">
          <div className="bradcams">
            <span className="bothss">
              <Link to="">My Account</Link>{" "}
              <img src="/images/brd_rowwo.png" alt="" /> Orders
              <img src="/images/brd_rowwo.png" alt="" /> Order Detail
            </span>
          </div>
          <div className="row">
            <div className="col-lg-3 mb_view_hide">
              <ProfileSidebar />
            </div>
            <div className="col-lg-9 my_orders">
              <h5 className="order-detail-title">Order Detail</h5>

              {/* Order Card */}
              {orders.map((order) => (
                <OrderCard key={order.orderId} {...order} />
              ))}

              {/* Shipping & Payment Info */}
              <div className="order-info-grid">
                {/* Shipping */}
                <div className="order-info-box">
                  <h6 className="info-title">Shipping Address</h6>
                  <p>{shippingAddress.name}</p>
                  <p style={{ whiteSpace: "pre-line" }}>
                    {shippingAddress.address}
                  </p>
                  <p>{shippingAddress.country}</p>
                  <p>{shippingAddress.phone}</p>
                </div>

                {/* Payment */}
                <div className="order-info-box">
                  <h6 className="info-title">Payment Information</h6>
                  <div className="info-row">
                    <span>Subtotal</span>
                    <span>{paymentInfo.subtotal}</span>
                  </div>
                  <div className="info-row">
                    <span>Shipping</span>
                    <span>{paymentInfo.shipping}</span>
                  </div>
                  <div className="info-row">
                    <span>Coupon Discount</span>
                    <span>{paymentInfo.discount}</span>
                  </div>
                  <div className="info-row total">
                    <span>Total</span>
                    <span>{paymentInfo.total}</span>
                  </div>
                  <hr />
                  <div className="info-row">
                    <span>Payment Mode</span>
                    <span>{paymentInfo.mode}</span>
                  </div>
                  <div className="info-row">
                    <span>Payment Status</span>
                    <span>{paymentInfo.status}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyOrderDetail;
